var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('editor',{attrs:{"value":_vm.value,"lang":_vm.lang,"theme":"chrome","width":"100%","height":_vm.height},on:{"input":function($event){return _vm.$emit('input', $event)},"init":_vm.editorInit}})
}
var staticRenderFns = []

export { render, staticRenderFns }